import React from 'react'
import { InspirationUniverseContext } from 'app/React/InspirationUniverse/InspirationUniverseContainer'
import StarsSvg from 'app/React/InspirationUniverse/StarsSvg'
import classNames from 'classnames'

export default function CoverSection () {

  const { tagline, title, buttonText, image, video, setNewUuid, isLoading } = React.useContext(InspirationUniverseContext)

  const renderMedia = () => {
    if (video) {
      return <video autoPlay muted loop>
        <source src={video} type="video/mp4"/>
        Your browser does not support HTML5 video.
      </video>
    }

    if (image) {
      return <img src={image} alt={title ?? 'cover image'}/>
    }
  }

  const handleShuffleOrder = () => {
    setNewUuid()
  }

  return (
    <section className="mtt-iu-cover">
      <div className="mtt-iu-cover__inner page_container">
        <div className="mtt-iu-cover__text-container">
          {tagline && (
            <p className="mtt-iu-cover__tagline iu-tagline iu-tagline--white">{tagline}</p>
          )}
          {title && (
            <h1 className="mtt-iu-cover__title">{title}</h1>
          )}
          <div className="mtt-iu-cover__button-container">
            <button
              className={classNames("mtt-iu-button mtt-iu-button--white", {
                "mtt-iu-button--loading": isLoading
              })}
              onClick={handleShuffleOrder}
            >
              <StarsSvg/>
              {buttonText}
            </button>
          </div>
        </div>
      </div>
      <div className="mtt-iu-cover__media-container object-fit">
        {renderMedia()}
      </div>
    </section>
  )
}
